exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".terms__header {\n  text-align: center; }\n  .terms__header h2 {\n    font-size: 32px; }\n\n.terms__content {\n  max-width: 850px;\n  padding: 20px 0; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js?sourceMap=true!./node_modules/sass-resources-loader/lib/loader.js??ref--1-oneOf-3-3!./src/components/Policies/Terms/index.scss
// module id = 6536
// module chunks = 1